import { forwardRef } from '@chakra-ui/react';

import { Button, ButtonProps } from '@bonusly/ds-button';

import { useAlertContext } from '../context';
import { AlertSize } from '../types';

const getSize = (alertSize: AlertSize) => (alertSize === 'md' ? 'sm' : 'xs');

const AlertAction = forwardRef<ButtonProps, 'div'>((props, ref) => {
	const { size } = useAlertContext();

	return <Button colorScheme="secondary" ref={ref} size={getSize(size)} variant="alpha" {...props} />;
});

AlertAction.displayName = 'AlertAction';

export { AlertAction };
